import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import SortObject from "../../../types/SortObject";
import { AuditModel } from "../../../viewModels/Audit/AuditModel";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  auditLog: Array<AuditModel>;

  total: number;
  pageSize: number;
  page: number;
  sort: SortObject;
} = {
  loading: true,
  loadingData: true,

  auditLog: undefined!,

  total: undefined!,
  pageSize: 10,
  page: 1,

  sort: undefined!,
};

const auditLogSlice = createSlice({
  name: "auditLog",
  initialState,
  reducers: {
    loadAuditLog(state) {
      state.loadingData = true;
      state.page = 1;
    },
    loadAuditLogSuccess(state, action: PayloadAction<{ data: Array<AuditModel>; count: number }>) {
      const { data, count } = action.payload;
      state.loading = false;
      state.loadingData = false;
      state.auditLog = data;
      state.total = count;
    },
    loadAuditLogError(state) {
      state.loading = false;
      state.loadingData = false;
    },
    changeTable(state, action: PayloadAction<{ page: number; pageSize: number; sort: SortObject }>) {
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
      state.sort = action.payload.sort;
      state.loadingData = true;
    },
    search(state) {
      state.loadingData = true;
    },
  },
});

export default auditLogSlice;
